import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RoomBooking from '../components/RoomBooking';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import ChatWidget from '../components/ChatWidget';
import { LiveVisitors } from '../components/LiveVisitors';
import { Toaster } from '../components/ui/toaster';

const RoomBookingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-4">
        <RoomBooking />
      </div>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <LiveVisitors />
      <Toaster />
    </div>
  );
};

export default RoomBookingPage;
